import { Card } from '@mui/material';
import React from 'react';
import * as IMG from '../../../helpers/ImagesUtils';

export const getSizeLayoutCarnet = () => {
  const h = 8.8; // cm
  const w = 5.6; // cm
  const dpi = 300;
  const scale = 0.5; // Escala del 20%

  const widthPx = (w * dpi) / 2.54;
  const heightPx = (h * dpi) / 2.54;

  const width = `${widthPx * scale}px`;
  const height = `${heightPx * scale}px`;

  return {
    width,
    height,
    wx: widthPx * scale,
    hx: heightPx * scale,
  };
};

const LayoutCarnet = ({ isReverse = false, cardRef, bg, children }) => {
  const width = `${getSizeLayoutCarnet().wx}px`;
  const height = `${getSizeLayoutCarnet().hx}px`;

  const border = '1.1px dashed #747474';

  const cardStyle = {
    width,
    height,
    backgroundImage: `url(${bg ?? IMG.c5})`,
    backgroundSize: `${width} ${height}`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    border: border,
    borderRight: isReverse ? border : 'none',
    borderLeft: !isReverse ? border : 'none',
  };

  return (
    <Card ref={cardRef} elevation={4} style={cardStyle}>
      {children}
    </Card>
  );
};

export default LayoutCarnet;
